import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import {
  SkillAvailableCurator,
  SkillSpecializationResponse,
} from '../../../models/skill-learning.model';
import { SpecializationFormValue } from '../specialization-form/specialization-form.component';

type SkillSpecializationInput = SkillSpecializationResponse | null;

@Component({
  selector: 'app-edit-specialization-general-page',
  templateUrl: './edit-specialization-general-page.component.html',
  styleUrls: ['./edit-specialization-general-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSpecializationGeneralPageComponent {

  @Input() specialization: SkillSpecializationInput = null;
  @Input() availableCurators: SkillAvailableCurator[] = [];
  @Input() canManageCurators: boolean = false;
  @Input() isSubmitting: boolean = false;

  @Output() generalInfoSaved = new EventEmitter<SpecializationFormValue>();
  @Output() cancelRequested = new EventEmitter<void>();

  onFormSubmitted(value: SpecializationFormValue): void {
    this.generalInfoSaved.emit(value);
  }

  onCancel(): void {
    this.cancelRequested.emit();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/edit-specialization-general-page/edit-specialization-general-page.component.ts